import { createDate } from '@unistocks/shared/utils/util';
import { WeekdayNumbers } from 'luxon';
import type { DateStringValue } from '../../types';

/**
 * Walks forwards from `date` to the last day of its week (the day before
 * `firstDayOfWeek`), returning it as a `yyyy-MM-dd` string. An invalid input is
 * passed straight back. Mirrors @mantine/dates `getEndOfWeek`.
 */
export function getEndOfWeek(
  date: DateStringValue,
  firstDayOfWeek: WeekdayNumbers = 1
): DateStringValue {
  let value = createDate(date);

  if (!value.isValid) {
    return date;
  }

  const lastDayOfWeek = firstDayOfWeek === 1 ? 7 : firstDayOfWeek - 1;
  while (value.weekday !== lastDayOfWeek) {
    value = value.plus({ days: 1 });
  }

  return value.toISODate();
}
